import { useMutation } from "@apollo/client";

import { ResumeRecurringDepositMutation, ResumeRecurringDepositMutationVariables } from "@ctypes";
import { RESUME_SIP } from "@graphql";

export const useResumeSip = () => {
  return useMutation<ResumeRecurringDepositMutation, ResumeRecurringDepositMutationVariables>(
    RESUME_SIP,
  );
};
